export default __webpack_public_path__ + "info.528006bb433ec789.svg";